import { __assign } from 'tslib';
import __vue_component__ from '../HseIconButton/HseIconButton.vue.js';
import { colorGrayDusk } from '@hse-design/tokens';
import Vue from 'vue';

/**
 * Иконка
 */
var script = Vue.extend({
    name: 'HseHeaderIcon',
    functional: true,
    props: {
        /**
         * Компонент иконки
         * @type {String | Vue.Component}
         */
        icon: {
            type: [String, Object, Function],
            default: ''
        }
    },
    render: function (h, ctx) {
        var _a, _b;
        var data = ctx.data, props = ctx.props, children = ctx.children, listeners = ctx.listeners;
        return h(__vue_component__, __assign(__assign({}, data), { props: __assign(__assign({ icon: props.icon, size: 'medium', variant: 'ghost' }, data.attrs), { iconColor: (_b = (_a = data.attrs) === null || _a === void 0 ? void 0 : _a.iconColor) !== null && _b !== void 0 ? _b : colorGrayDusk }), on: listeners }), children);
    }
});

export default script;
